import React from 'react';
import { Link } from 'react-router-dom';
import AppStore from '../../assets/images/appstore.png';
import Smilly from '../../assets/images/smily.png';
import Reviewimg from '../../assets/images/review1.png';
import Reviewimg1 from '../../assets/images/review2..png';
import Reviewimg2 from '../../assets/images/review3..png';

const reviewData = [
    {
        name: 'Willium Joy',
        company: 'Smartbrain Tech',
        stars: 5,
        text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente culpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatum nam pariatur? Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, totam.',
        avatar: Reviewimg,
    },
    {
        name: 'John Due',
        company: 'Corporate Agency',
        stars: 5,
        text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente culpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatum nam pariatur? Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur et, nemo distinctio eum omnis quam!',
        avatar: Reviewimg1,
    },
    {
        name: 'Maria',
        company: 'Company Inc',
        stars: 5,
        text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente culpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatum nam pariatur? Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur et, nemo distinctio eum omnis quam!',
        avatar: Reviewimg2,
    },
];

function Review() {
    return (
        <>
            <section className="review_section row_am">
                <div className="container">
                    <div className="positive_inner">
                        <div className="row">
                            <div className="col-md-6 sticky-top">
                                <div className="sidebar_text"
                                    data-aos="fade-up" data-aos-duration={1500} >
                                    <div className="section_title text-left">
                                        <span className="title_badge">Recenzii</span>
                                        <h2>
                                            Ce cred utilizatorii despre <span> LUMO </span>
                                        </h2>
                                    </div>
                                    <div className="google_rating">
                                        <div className="star">
                                            {Array.from({ length: 5 }, (_, i) => (
                                                <span key={i}>
                                                    <i className="icofont-star" />
                                                </span>
                                            ))}
                                        </div>
                                        <p>
                                            4.9/5.0
                                        </p>
                                    </div>
                                    <div className="user_review">
                                        <p>
                                            24 de utilizatori și-au spus{' '}
                                            <Link to="#">
                                                părerea <i className="icofont-arrow-right" />{' '}
                                            </Link>
                                        </p>
                                    </div>
                                    <div className="smiley_icon">
                                        <img src={Smilly} alt="image" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="review_side">
                                    {reviewData.map((review, index) => (
                                        <div key={index} className="review_block"
                                            data-aos="fade-up" data-aos-duration={1500} >
                                            <div className="coustomer_info">
                                                <div className="avtar">
                                                    <img src={review.avatar} alt="image" />
                                                    <div className="text">
                                                        <h3>{review.name}</h3>
                                                        <span>{review.company}</span>
                                                    </div>
                                                </div>
                                                <div className="star">
                                                    {Array.from({ length: review.stars }, (_, i) => (
                                                        <span key={i}>
                                                            <i className="icofont-star" />
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                            <p>{review.text}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Review;
